<template>
  <div>
    <div class="rn-box" v-if="list.length">
      <i class="iconfont icon-laba"></i>
      <div class="rn-box-l">
        <van-notice-bar :scrollable="false">
          <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false" @change="onChange">
            <template v-for="(item, index) in list">
              <van-swipe-item :key="index">{{ item.content }}</van-swipe-item>
            </template>
          </van-swipe>
        </van-notice-bar>
      </div>
      <span @click="view">View</span>
    </div>
    <div class="ex" v-if="homeBanners && homeBanners.length">
      <pageBanner :list="homeBanners" v-if="homeBanners && homeBanners.length"></pageBanner>
    </div>
    <div
      class="ex-txt"
      :class="{
        view_false: exhibitionConfig && !exhibitionConfig.feature.enabledDataStatistics,
      }"
      v-if="openAll"
    >
      <div class="ex-txt-l" v-if="exhibitionConfig && exhibitionConfig.feature.enabledDataStatistics && (exOnInfo.userCount || exOnInfo.viewCount)">
        <van-swipe style="height: 100%;" vertical autoplay="3000" :touchable="false" :show-indicators="false">
          <van-swipe-item v-if="openView">
            <div class="item">
              {{ exOnInfo.userCount ? countThous(exOnInfo.userCount) : "" }}
              professionals have visited
            </div>
          </van-swipe-item>
          <van-swipe-item v-if="openViewNum">
            <div class="item">
              {{ exOnInfo.viewCount ? countThous(exOnInfo.viewCount) : 0 }}
              visits in total
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- <div class="ex-txt-r" v-if="exhibitionConfig && exhibitionConfig.feature.enabledSupplyDemand && supplyList.length">
        <div class="txt">
          <div class="brand">供需</div>
          <div class="supplt_list" v-if="supplyList.length">
            <van-swipe style="height: 100%;" vertical autoplay="3000" :show-indicators="false">
              <van-swipe-item v-for="(item,index) in supplyList" :key="index" @click="LinkToSupply(item.id)">
                <p>{{item.content}}</p>
              </van-swipe-item>
            </van-swipe>
          </div>
          <p style="margin-left: 0.34rem;" v-else>暂无数据</p>
        </div>
      </div> -->
    </div>
    <!-- 分享 -->
    <liveShare ref="liveShare"></liveShare>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import pageBanner from "./pageBanner";
import liveShare from "@/components/live-share/index"; //分享
import { mapGetters, mapActions } from "vuex";
import { Dialog } from "vant";
export default {
  name: "ex-card",
  props: {
    power: {
      type: Array,
      default: [
        { open: true, title: "浏览人数" },
        { open: true, title: "浏览量" },
      ],
    },
  },
  data() {
    return {
      isFollow: false,
      exOnInfo: {}, //展会信息数据
      giveExOn: {}, //展会信息接口
      supplyList: [],
      querySupplyDemand: {}, //供需接口
      shareV: {
        content: "",
        poster: "",
      },
      isShareV: true,
      homeBanners: [], //展会首页banner
      banners: {},
      list: [],
      current: 0,
    };
  },
  components: { pageBanner, liveShare },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exonId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      exhibitionConfig: "getExhibitionConfig",
    }),
    exhibitionId() {
      return this.$route.params.id || this.exonId;
    },
    openView() {
      let bool = true;
      this.power.forEach((c) => {
        if (c.title === "浏览人数") {
          bool = c.open;
        }
      });
      return bool;
    },
    openViewNum() {
      let bool = true;
      this.power.forEach((c) => {
        if (c.title === "浏览量") {
          bool = c.open;
        }
      });
      return bool;
    },
    openAll() {
      let num = 0;
      let bool = true;
      this.power.forEach((c) => {
        if (c.open === false) {
          num += 1;
        }
      });
      if (num === this.power.length) {
        bool = false;
      }
      return bool;
    },
    option() {
      return {
        where: {
          Equal_exhibitionId: {
            n: "exhibitionId",
            v: this.exhibitionId,
          },
          Equal_SendUserType: {
            n: "SendUserType",
            v: 1,
          },
          Equal_pushPosition: {
            n: "pushPosition",
            v: "home",
          },
          Equal_isdeleted: {
            n: "isDeleted",
            v: false,
          },
          Equal_lang: {
            n: "langVersion",
            v: "en",
          },
        },
        order: [{ N: "createAt", V: "0" }],
        page: 1,
        size: 100,
      };
    },
  },
  async created() {
    await this.$Myapollo.getUserInfo(this);
    this.addExonView();
    this.checkShareInfo();
    this.getList();
  },
  methods: {
    ...mapActions({
      addExhibitionFollower: "follower/addExhibitionFollower", //展会关注
      delExhibitionFollower: "follower/delExhibitionFollower", //取消展会关注
      getShareConfig: "wxShare/getShareConfig", //分享
      addExhibitionView: "follower/addExhibitionView",
      LinkToSupply: "linkTo/LinkToSupply",
      getSettingShare: "wxShare/getSettingShare", //分享配置
      getAnnouncement: "getAnnouncement",
    }),
    async getList() {
      let list = await this.getAnnouncement(this.option);
      // console.log(list,'公告')
      let arr = [];
      if (list && list.items && list.items.length) {
        arr = list.items;
      } else {
        arr = [];
      }
      arr.forEach((c) => {
        if (this.compareDate(c.pushStart, c.pushEnd)) {
          this.list.push(c);
        }
      });
    },
    compareDate(statedate1, enddate1) {
      let statedate = statedate1.slice(0, 10) + " " + statedate1.slice(11, 19);
      let enddate = enddate1.slice(0, 10) + " " + enddate1.slice(11, 19);
      const stateTime = new Date(statedate.replace(/-/g, "/")).getTime();
      const Time = new Date().getTime();
      const endTime = new Date(enddate.replace(/-/g, "/")).getTime();
      if (stateTime < Time && Time < endTime) {
        return true; //进行中
      } else if (endTime < Time) {
        return false; //已结束
      } else {
        return false; //未开始
      }
    },
    onChange(index) {
      console.log(index, "----");
      this.current = index;
    },
    // 查看公告
    view() {
      let msg = this.list[this.current].content;
      Dialog.alert({
        title: "Notification",
        message: msg,
        confirmButtonColor: "#1890ff",
        messageAlign: "left",
        width: "300px",
        className: "dialog",
        confirmButtonText: "Submit",
      }).then(() => {
        // on close
      });
    },
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    async addExonView() {
      let opt = {
        exhibitionId: this.exhibitionId,
        target: "exhibition",
        targetId: this.exhibitionId,
      };
      if (this.userInfo && this.userInfo.userId) {
        opt.userId = this.userInfo.userId;
      }
      this.addExhibitionView(opt);
      this.getExonInfo();

      await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, "");
    },
    //设置分享信息
    checkShareInfo() {
      this.$store.commit("wxShare/setFromType", 0);
      let userInfo = {
        name: this.userInfo.nickName || this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl,
      };
      let body = {
        exhibitionId: this.exhibitionId,
        userId: this.userInfo.userId,
        userInfo: JSON.stringify(userInfo),
        fromType: 0,
      };
      this.$store.commit("wxShare/setFromData", body);
    },
    //千分位加逗号
    countThous(n) {
      let num = n.toString();
      let decimals = "";
      // 判断是否有小数
      num.indexOf(".") > -1 ? (decimals = num.split(".")[1]) : decimals;
      let len = num.length;
      if (len <= 3) {
        return num;
      } else {
        let temp = "";
        let remainder = len % 3;
        decimals ? (temp = "." + decimals) : temp;
        if (remainder > 0) {
          // 不是3的整数倍
          return (
            num.slice(0, remainder) +
            "," +
            num
              .slice(remainder, len)
              .match(/\d{3}/g)
              .join(",") +
            temp
          );
        } else {
          // 是3的整数倍
          return (
            num
              .slice(0, len)
              .match(/\d{3}/g)
              .join(",") + temp
          );
        }
      }
    },
    //展会banner
    getBanners() {
      const query = gql`
        query banners($exhibitionId: Guid!) {
          banners(exhibitionId: $exhibitionId, position: "show.page.home.en") {
            content
            covers
            enabledCountdown
            url
            endAt
            showIndex
            createAt
          }
        }
      `;
      this.$apollo.addSmartQuery("banners", {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
        },
        fetchPolicy: "no-cache", //清理缓存
        result(res) {
          console.log("请求回来了banners", res);
          let data = JSON.parse(JSON.stringify(res.data.banners));
          if (data && data.length) {
            console.log(this.homeBanners, "homeBanners");
          } else {
            this.homeBanners = [];
          }
          this.$emit("requestOk", "bannersIsOk"); //banner获取完成
        },
        error(err) {},
      });
    },
    initExInfo() {
      this.homeBanners = [];
      let data = this.exhibitionInfo.exhibition;
      data.exTime = moment(data.startData).format("YYYY/MM/DD") + "~" + moment(data.endDate).format("MM/DD");
      this.isFollow = data.isFollow;
      this.exOnInfo = data;
      data.banners.forEach((e) => {
        e.day = 1;
        if (e.enabledCountdown && e.content.indexOf("【时间】") != -1) {
          let day = moment(moment(e.endAt)).diff(moment(moment().startOf("day")), "days");
          e.content = e.content.replace(/【时间】/, ` ${day} `);
          e.day = day;
        }
      });
      data.banners.sort((a, b) => {
        if (a.showIndex == b.showIndex) {
          return moment(a.createAt).valueOf() - moment(b.createAt).valueOf();
        } else {
          return b.showIndex - a.showIndex;
        }
      }); 
      if (data.banners.length) {
        this.homeBanners = data.banners;
      } else {
        let demo = {
          content: "",
          url: "",
          covers: data.banner,
          enabledCountdown: false,
        };
        this.homeBanners = [demo];
      } 
      this.$Bus.$emit("bannerChange", this.homeBanners[0].covers);
      this.$emit("requestOk", "bannersIsOk"); //供需获取完成
      this.$nextTick(() => {
        this.getShareData();
        this.getSupply();
      });
    },
    getExonInfo() {
      const query = gql`
        query exhibition($id: Guid!) {
          giveExOn: exhibition(id: $id) {
            address #举办地点
            startData #开始日期
            endDate #结束日期
            followCount #关注数量
            viewCount #浏览数量
            userCount #访问数量
            remark #介绍
            logo #展会logo
            name #展会名称
            nameEn
            shortName #展会简称
            shortNameEn
            host {
              address
              createAt
              id
              isDeleted
              linkName
              logo
              name
              phone
              remark
              shortName
              updateAt
            }
            banner #海报
            bannerEn
            banners(position: "show.page.home.en") {
              covers #封面 多个用;隔开
              content #内容
              enabledCountdown #是否启用倒计时
              exhibitionId #展会Id
              url #链接
              endAt
              createAt
              showIndex
            }
          }
        }
      `;
      this.$apollo.addSmartQuery("giveExOn", {
        query: query,
        variables: {
          id: this.exhibitionId,
        },
        fetchPolicy: "no-cache", //清理缓存
        result(res) {
          let data = JSON.parse(JSON.stringify(res.data.giveExOn));
          if (data) {
            this.$store.commit("setHostInfo", data.host);
            data.exTime = moment(data.startData).format("YYYY/MM/DD") + "~" + moment(data.endDate).format("MM/DD");
            this.isFollow = data.isFollow;
            this.exOnInfo = data;
            this.$store.commit("setExhibitionInfo", { exhibition: data });
            data.banners.forEach((e) => {
              e.day = 1;
              if (e.enabledCountdown && e.content.indexOf("【时间】") != -1) {
                let day = moment(moment(e.endAt)).diff(moment(moment().startOf("day")), "days");
                e.content = e.content.replace(/【时间】/, ` ${day} `);
                e.day = day;
              }
            });
            data.banners.sort((a, b) => {
              if (a.showIndex == b.showIndex) {
                return moment(a.createAt).valueOf() - moment(b.createAt).valueOf();
              } else {
                return a.showIndex - b.showIndex;
              }
            });
            if (data.banners.length) {
              this.homeBanners = data.banners; 
            } else {
              let demo = {
                content: "",
                url: "",
                covers: data.bannerEn,
                enabledCountdown: false,
              };
              if (demo.covers) {
                this.homeBanners = [demo];
              }
            }
            this.$Bus.$emit("bannerChange", this.homeBanners.length ? this.homeBanners[0].covers : "");
            this.$emit("requestOk", "bannersIsOk"); //供需获取完成
            this.$nextTick(() => {
              this.getShareData();
              this.getSupply();
            });
          }
          this.$emit("requestOk", "exInfoIsOk"); //展会信息获取完成
        },
        error(err) {},
      });
    },
    getSupply() {
      const query = gql`
        query querySupplyDemand($query: QueryInput!) {
          querySupplyDemand(query: $query) {
            items {
              content
              id
            }
          }
        }
      `;
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let where = {
        EqualB: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        EqualC: {
          n: "auditState",
          v: 1,
        },
      };
      let opt = {
        page: 1,
        size: 3,
        order: JSON.stringify(order),
        where: JSON.stringify(where),
      };
      this.$apollo.addSmartQuery("querySupplyDemand", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only", //清理缓存
        result(res) {
          let data = JSON.parse(JSON.stringify(res.data.querySupplyDemand));
          if (data) {
            this.supplyList = data.items;
          }
          this.$emit("requestOk", "supplyIsOk"); //供需获取完成
        },
        error(err) {},
      });
    },
    async addFollow() {
      let userInfo = {
        name: this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl,
        nickName: this.userInfo.nickName,
      };
      let opt = {
        exhibitionId: this.exhibitionId,
        userId: this.userInfo.userId,
        userInfo: JSON.stringify(userInfo),
      };
      let res = await this.addExhibitionFollower(opt);
      if (res.result) {
        this.$toast.success("关注成功");
        this.isFollow = true;
        this.exOnInfo.followCount += 1;
      } else {
        this.$toast.fail("关注失败");
      }
    },
    async delFollow() {
      let opt = {
        exhibitionId: this.exhibitionId,
        userId: this.userInfo.userId,
      };
      let res = await this.delExhibitionFollower(opt);
      if (res.result) {
        this.exOnInfo.followCount -= 1;
        this.$toast.success("取消关注");
        this.isFollow = false;
      } else {
        this.$toast.fail("取消失败");
      }
    },
    async getShareVal() {
      let res = await this.getSettingShare({
        id: this.exhibitionId,
        name: "share.exhibition.en.config",
      });
      if (res) {
        this.shareV = JSON.parse(res);
      }
      this.isShareV = true;
    },
    //分享点击
    async share() {
      console.log(this.exOnInfo, "ssss");
      let opt = {
        title: "Recommend an exhibition for you",
        bannerTitle: this.exOnInfo.nameEn || this.exOnInfo.shortNameEn || "Show online",
        subhead: "Show online",
        banner: this.shareV.poster ? [this.shareV.poster] : [this.exOnInfo.bannerEn],
        type: "home",
      };
      this.$nextTick(() => {
        this.$refs["liveShare"].open(opt);
      });
      await true;
    },
    //分享标题，内容，图片
    async getShareData() {
      await this.getShareVal();
      let shareData = {
        title: this.shareV && this.shareV.content ? this.shareV.content : "Recommend an exhibition for you",
        desc: this.shareV && this.shareV.des ? this.shareV.des : this.exOnInfo.nameEn,
        imgUrl: this.exOnInfo.logo,
      };
      this.$nextTick(() => {
        this.$refs.liveShare.shareTo(shareData);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ex {
  margin: 0 0.3rem 0.3rem;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.exInfo {
  padding: 0.25rem 0.2rem;
  display: flex;
  justify-content: space-between;
  .ex-left {
    width: calc(100% - 2.2rem);
    .ex-title {
      font-size: 0.26rem;
      font-weight: 600;
      line-height: 1.5;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding-bottom: 3px;
      span {
        font-size: 0.26rem;
      }
    }
    p {
      font-size: 0.2rem;
      line-height: 1.5;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .ex-rigth {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 2.2rem;
    .r-t {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      span {
        width: 1rem;
        height: 0.46rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        font-size: 0.22rem;
      }
      span:first-child {
        margin-right: 0.2rem;
        background-color: #0190fe;
        color: #fff;
      }
      span:last-child {
        background-color: #fff;
        border: solid 1px #e6e6e6;
        color: #333;
      }
      .hasFollow {
        background-color: #e6e6e6 !important;
      }
    }
    .r-b {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #999;
      font-size: 0.22rem !important;
      span {
        display: flex;
        align-items: center;
        font-size: 0.22rem !important;
      }
      span:first-child {
        margin-right: 0.2rem;
      }
    }
  }
}
.ex-txt {
  display: flex;
  margin: 0.3rem;
  align-items: center;
  &.view_false {
    .ex-txt-r {
      width: 100%;
    }
  }
  &-l {
    font-size: 0.24rem;
    color: #0190fe;
    width: 100%;
    height: 0.3rem;
    overflow: hidden;
    font-weight: bold;
  }
  &-r {
    width: 40%;
    display: flex;
    align-items: center;
    background-color: #fff;
    font-size: 12px;
    color: #333;
    border-radius: 3px;
    background-color: #fff;
    background-image: url("../../../assets/img/new/supply_bg.png");
    background-repeat: no-repeat;
    background-size: contain;
    padding-left: 0.14rem;
    .txt {
      display: flex;
      height: 0.48rem;
      border-radius: 3px;
      align-items: center;
      width: 100%;
      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .supplt_list {
        height: 100%;
        margin-left: 0.34rem;
        max-width: calc(100% - 0.88rem);
        .van-swipe-item {
          display: flex;
          align-items: center;
        }
      }
      .brand {
        flex-shrink: 0;
        color: #fff;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.rn-box {
  margin: 0.22rem 0.3rem 0.22rem 0.3rem;
  border-radius: 0.1rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0.24rem;
  height: 0.7rem;
  align-items: center;
  background: #fff;
  color: #666;
  font-size: 0.24rem;
  box-shadow: 0px 3px 5px 0px rgba(171, 170, 170, 0.33);
  i {
    color: #0190fe;
    // @include font_color_secondary2(#1890ff);
    transform: scale(1.5);
    margin-right: 0.18rem;
    vertical-align: middle;
  }
  &-l {
    flex: 1;
    height: 0.7rem;
    .van-notice-bar {
      height: 100%;
      background: #fff;
      padding: 0;
      color: #666;
      .notice-swipe {
        height: 24px;
        line-height: 24px;
      }
      .van-swipe-item {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 4.6rem;
      }
    }
  }
  span {
    color: #1890ff;
    // @include font_color(#1890ff);
  }
}
</style>
